import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableAggregated = _resolveComponent("TableAggregated")!

  return (_openBlock(), _createBlock(_component_TableAggregated, {
    class: "region-aggregated-table",
    "data-pdf-repeat-leading-cols": "1",
    filterParams: _ctx.filter,
    storePaths: _ctx.storePaths,
    generateColumns: _ctx.generateColumns,
    rowClassGetter: _ctx.rowClassGetter,
    cellClassGetter: _ctx.cellClassGetter,
    isArrowNav: "",
    loadStrategy: "progressive",
    progressBarOptions: _ctx.getProgressBarOptions,
    notFoundMode: "outside",
    pagination: _ctx.getPaginationConfig
  }, null, 8, ["filterParams", "storePaths", "generateColumns", "rowClassGetter", "cellClassGetter", "progressBarOptions", "pagination"]))
}